import { render, staticRenderFns } from "./Brand.vue?vue&type=template&id=65c87e20"
import script from "./Brand.vue?vue&type=script&lang=js"
export * from "./Brand.vue?vue&type=script&lang=js"
import style0 from "./Brand.vue?vue&type=style&index=0&id=65c87e20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports